<p-dialog
  [header]="header"
  [(visible)]="visible"
  [modal]="true"
  [focusOnShow]="focusOnShow"
  (onHide)="close()"
  [style]="{ width: '70vw', maxWidth: '900px' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '75vh' }"
>
<ng-content></ng-content>
</p-dialog>